export default __webpack_public_path__ + "static/media/light-circle.aea1457d.svg";